<template>
  <section id="demo" class="booking section-card" aria-labelledby="booking-heading" v-reveal>
    <div class="booking-text">
      <h2 id="booking-heading" class="title title-lg booking-title">
        Ready to make<br />shipping effortless?
      </h2>
      <p class="subtitle subtitle-booking">
        Book a personalized demo and see how SoonForward can help your business.
      </p>
    </div>

    <span class="booking-divider"></span>

    <div class="booking-form">
      <div class="booking-inputs">
        <input
          v-model="email"
          type="email"
          class="booking-email-input"
          placeholder="Enter your work email..."
          aria-label="Work email address"
        />
        <a
          :href="calendlyUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-sm"
          aria-label="Book a demo (opens in a new tab)"
        >Book a demo</a>
      </div>
      <ul class="booking-checks">
        <li v-for="check in bookingChecks" :key="check" class="booking-check">
          <span class="icon-badge booking-check-icon"><b-icon-check aria-hidden="true" /></span>
          {{ check }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import reveal from '../directives/scrollReveal';
import '../assets/styles/landing-shared.scss';

export default {
  name: 'Landing2Booking',
  directives: {
    reveal,
  },
  data() {
    return {
      bookingChecks: ['No commitment', 'Personalized walkthrough', 'Book in minutes'],
      email: '',
    };
  },
  computed: {
    calendlyUrl() {
      const base = 'https://calendly.com/soonforwarddelivery/30min';
      return this.email ? `${base}?email=${encodeURIComponent(this.email)}` : base;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/fluid';

.booking-title {
  margin-bottom: 1rem;
  color: var(--color-white);
}

.subtitle-booking {
  max-width: 25.625rem;
  font-size: 1rem;
  line-height: 1.25rem;
  color: rgba(255, 255, 255, 0.75);
}

.booking {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
  height: 19rem;
  padding: 4.5rem 4rem;
  background: var(--color-primary);
}

.booking-text {
  flex: 0 0 auto;
  max-width: 30rem;
}

.booking-divider {
  flex: 0 0 auto;
  align-self: stretch;
  width: 1px;
  background: rgba(255, 255, 255, 0.25);
}

.booking-form {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 1.5rem;
  width: 39rem;
}

.booking-inputs {
  display: flex;
  gap: 1rem;
}

.booking-inputs .btn {
  background: #171717;
  color: var(--color-white) !important;
  font-weight: 500;
}

.booking-email-input {
  flex: 1;
  height: 3rem;
  padding: 0 1.25rem;
  border: none;
  border-radius: 1.5rem;
  background: var(--color-white);
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-text);
}

.booking-email-input::placeholder {
  color: var(--color-text-muted);
}

.booking-checks {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.booking-check {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.1875rem;
  color: var(--color-white);
  white-space: nowrap;
}

.booking-check-icon {
  width: 1.5rem;
  height: 1.5rem;
  background: var(--color-white);
}

.booking-check-icon svg {
  width: 1.25rem;
  height: 1.25rem;
}

@media (max-width: 767px) {
  .booking {
    flex-direction: column;
    height: auto;
    padding: 3rem 1.375rem 4rem;
  }

  .booking-text {
    max-width: none;
    text-align: center;
  }

  .booking-title {
    font-size: 1.875rem;
    line-height: 1.875rem;
  }

  .subtitle-booking {
    max-width: 17.5625rem;
    margin: 0 auto;
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .booking-divider {
    display: none;
  }

  .booking-form {
    width: 100%;
    gap: 2rem;
  }

  .booking-inputs {
    flex-direction: column;
    gap: 1rem;
  }

  .booking-email-input {
    flex: 0 0 auto;
    width: 100%;
    padding: 0 1rem;
  }

  .booking-inputs .btn {
    width: 100%;
  }

  .booking-checks {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .booking-check-icon svg {
    width: 1.25rem;
    height: 1.25rem;
  }
}

@media (min-width: 768px) and (max-width: 1439px) {
  .booking {
    flex-direction: column;
    height: auto;
    padding: 3rem fluid(1.375rem, 4rem) 4rem;
  }

  .booking-text {
    max-width: none;
    text-align: center;
  }

  .subtitle-booking {
    max-width: fluid(17.5625rem, 25.625rem);
    margin: 0 auto;
    font-size: fluid(0.75rem, 1rem);
    line-height: fluid(1rem, 1.25rem);
  }

  .booking-divider {
    display: none;
  }

  .booking-form {
    width: 100%;
    gap: 2rem;
  }

  .booking-inputs {
    flex-direction: column;
    gap: 1rem;
  }

  .booking-email-input {
    flex: 0 0 auto;
    width: 100%;
    padding: 0 fluid(1rem, 1.25rem);
  }

  .booking-inputs .btn {
    width: 100%;
  }

  .booking-checks {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}
</style>
